import React from 'react'
import { useState, useEffect } from 'react'
import { Carousel } from 'react-bootstrap'
import placeholder from '../img/placeholder.png'
import black from '../img/black.jpg'
import { Link } from 'react-router-dom';
import {apiThisMonthEvents} from '../api/api.js'
import './EventBanner.css'

const EventBanner = () => {
  var today = new Date();
  var month = String(today.getMonth() + 1).padStart(2, '0');
  var year = String(today.getFullYear());

  const [eventTM, setEventTM] = useState('');
  const getThisMonthsEvents = () => {
    apiThisMonthEvents(month, year)
    .then((response)=> {
      console.log(response)
      const thisMonthEventsArray = response.data.content;
      setEventTM(thisMonthEventsArray)
    })
  }
  useEffect(() => {
    getThisMonthsEvents();
  }, []);
  
  const carouselEvent = []
  if (eventTM !== ''){
    for (var i = 0; i<eventTM.length; i++){
      var tanggal = eventTM[i].dateTime.substring(8, 10) 
      var bulan = eventTM[i].dateTime.substring(5, 7) 
      var tahun = eventTM[i].dateTime.substring(0, 4) 
      var dateFormat = tanggal + '/' + bulan + '/' + tahun
      carouselEvent.push(
        <Carousel.Item>
              <Link to={`/event/${eventTM[i]._id}`}>
              <img
                className="img-slide"
                src={eventTM[i].image? eventTM[i].image : placeholder}
              />
              
            <Carousel.Caption>
              <p className='carouselText'>{eventTM[i].name} ({dateFormat})</p>
            </Carousel.Caption>
              </Link>
            </Carousel.Item>
      )
    }
  }
    return (
      <div className='BannerContainer'>
        <p className='eventBannerTitle'>This Month's Event</p>
        <div className='Carousel'>        
          {eventTM.length !== 0? 
          <Carousel variant='dark'>
          {carouselEvent}
          </Carousel>
          :
          <Carousel variant='dark' controls={false}>
          <Carousel.Item>
            <img
              className="img-slide"
              src={black}
            />
          <Carousel.Caption>
            <p className='noEvent'>There is currently no event for this month</p>
          </Carousel.Caption>
          </Carousel.Item>
          </Carousel>
          }        
        </div>
      </div>
    );
  }
  
  export default EventBanner